"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const usePostMessage_1 = require("src/hooks/usePostMessage");
const Requests_1 = __importDefault(require("./main/Requests"));
const EventHandler_1 = __importDefault(require("./main/EventHandler"));
require("src/styles/widget.scss");
const usePostMessage = usePostMessage_1.usePostMessage;
class Widget {
    constructor() {
        this.identify = (data) => __awaiter(this, void 0, void 0, function* () {
            console.log("[Widget.identify]");
            if (data === null || data === void 0 ? void 0 : data.key) {
                this._widgetKey || (this._widgetKey = data.key);
            }
            if (!this._widgetKey)
                return;
            yield this._Requests
                .identify(data.data, this._widgetKey, data.token)
                .then((res) => __awaiter(this, void 0, void 0, function* () {
                this._user = res.data;
            }))
                .catch(console.error);
            usePostMessage({
                type: "send_user_to_handle",
                data: { user: this._user },
            });
        });
        this.track_tour = (data) => __awaiter(this, void 0, void 0, function* () {
            console.log("[Widget.track]");
            if (!this._widgetKey)
                return;
            yield this._Requests.track_tour(data.tour_id, data.data, this._widgetKey, this._user.token).catch(console.error);
        });
        this.fetchData = (data) => __awaiter(this, void 0, void 0, function* () {
            console.log("[Widget.fetchData]");
            this._widgetKey = data.key;
            yield this._Requests
                .getHotspots(this._widgetKey)
                .then((res) => __awaiter(this, void 0, void 0, function* () {
                const { list, user } = yield res.data;
                const { has_project_access } = user;
                this._hotspots = list;
                this._isAdmin = has_project_access;
            }))
                .catch(console.error);
            yield this._Requests
                .getTours(this._widgetKey)
                .then((res) => __awaiter(this, void 0, void 0, function* () {
                const { list, user } = yield res.data;
                const { has_project_access } = user;
                this._tours = list;
                this._isAdmin = has_project_access;
            }))
                .catch(console.error);
            usePostMessage({ type: "observe" });
            usePostMessage({
                type: "send_data_to_handle",
                data: { isAdmin: this._isAdmin, tours: this._tours, hotspots: this._hotspots },
            });
        });
        console.log("[Widget.constructor]");
        this._postMessageHandlerMap = {
            identify: this.identify,
            track_tour: this.track_tour,
            fetchData: this.fetchData,
        };
        this._Requests = new Requests_1.default();
        new EventHandler_1.default(this._postMessageHandlerMap).register();
    }
}
new Widget();
usePostMessage({ type: "widgetLoaded" });
